import { I3pService } from '@nuxtDatakodeUtils/services/i3p.service'
import type { I3pServiceInterface } from '@nuxtDatakodeUtils/services/i3p.service.interface'
import { Opportunity } from '~/models/Opportunity'

type OpportunityData = PildomModules.Voirie.Data.OpportunityData

export class OpportunitiesI3pService extends I3pService<OpportunityData> implements I3pServiceInterface {
    readonly type = 'opportunity'
    getModel(): Opportunity {
        return new Opportunity()
    }

    getLayerName(): string {
        return 'Opportunités'
    }

    getLayerNameIntentions(): string {
        return 'Intentions'
    }
}
